module.exports = __webpack_public_path__ + "static/media/webapp-market.62db2ae7.png";